import { useQuery } from 'react-query';
import { getAllBlogs, getMainBlog, getCategories } from '../../api/home';


export const BLOG_QUERY_KEY = 'blogs-';

export const useGetAllBlogs = (params, enabled, variable) => {
    const query = useQuery([BLOG_QUERY_KEY + variable, ],  async () => getAllBlogs(params), {
        enabled,
        refetchOnWindowFocus: false,
      });
    return query;
};

export const useGetMainBlog = () => {
    const query = useQuery(BLOG_QUERY_KEY + "main", async () => getMainBlog(), {
        refetchOnWindowFocus: false,
    });
    return query;
};


export const useGetCategories = () => {
    const query = useQuery(BLOG_QUERY_KEY + "categories", async () => getCategories(), {
        refetchOnWindowFocus: false,
    });
    return query;
};
